export class AssignConfig {
    operator: string;
    multiSelect: boolean;
    necessary: boolean;
    allowGlobalAssign?: boolean;
    assignScope?: any;
}